import * as Yup from 'yup';
import * as yup from 'yup';
import { messages } from 'app/config/constants';

export const constructionFeeValidationSchema = yup.object().shape({
  iban: Yup.string().required(messages.MANDATORY_FIELD),
  estimatedConstructionCost: Yup.array().of(Yup.object()).required(messages.MANDATORY_FIELD).min(1, messages.MANDATORY_FIELD),
  calculatedConstructionFeeAmount: Yup.number().moreThan(0, 'Iznos mora biti veći od 0!').nullable(),
  specialConstructionCommencementFee: Yup.number().moreThan(0, 'Iznos mora biti veći od 0!').nullable(),
});
